module.exports = __webpack_public_path__ + "static/media/4.958d7677.jpg";